<template>
    <div v-if="sortedModelings">
        <router-view :modelsData="sortedModelings"></router-view>
    </div>
</template>

<script>
    import { sizeGuideService } from '../../../../../submodules/src/service/resource';

    export default {
        name: 'SizesGuidePage',

        data() {
            return {
                modelsData: null,
            };
        },

        created() {
            this.fetchModels();
        },

        computed: {
            sortedModelings() {
                if (this.modelsData) {
                    return this.modelsData.sort((a, b) =>
                        a.product_type.ordem > b.product_type.ordem || a.id < b.id ? 1 : -1
                    );
                }
            },
        },

        methods: {
            fetchModels() {
                sizeGuideService.getSizeGuideMedia().then((response) => {
                    this.modelsData = response.data;
                });
            },
        },
    };
</script>
